import React from 'react';
import { Info, CheckCircle2, AlertTriangle, AlertCircle, X } from 'lucide-react';
import { cn } from '../../utils/cn';

const VARIANTS = {
  info:    { cls: 'bg-info-bg text-info border-info/30',       Icon: Info },
  success: { cls: 'bg-success-bg text-success border-success/30', Icon: CheckCircle2 },
  warn:    { cls: 'bg-warn-bg text-warn border-warn/30',       Icon: AlertTriangle },
  danger:  { cls: 'bg-danger-bg text-danger border-danger/30', Icon: AlertCircle },
  neutral: { cls: 'bg-bg-2 text-text border-border',           Icon: Info },
};

export function Alert({ variant = 'info', title, action, onClose, className, children, ...rest }) {
  const { cls, Icon } = VARIANTS[variant];
  return (
    <div role="alert" className={cn('flex items-start gap-3 border rounded-lg p-3.5', cls, className)} {...rest}>
      <Icon className="w-[18px] h-[18px] shrink-0 mt-0.5" strokeWidth={1.8} />
      <div className="flex-1 leading-tight">
        {title && <div className="text-sm font-semibold">{title}</div>}
        {children && <div className={cn('text-sm leading-relaxed', title && 'mt-1')}>{children}</div>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
      {onClose && (
        <button type="button" onClick={onClose} aria-label="Fermer" className="shrink-0 -mr-1 -mt-1 p-1 rounded hover:bg-text/10 transition-colors">
          <X className="w-3.5 h-3.5" strokeWidth={2} />
        </button>
      )}
    </div>
  );
}

export default Alert;
